export default "__VITE_ASSET__Di2v0NDi__"